import PATHS from 'pages/paths'

const { UNAUTHENTICATED, AUTHENTICATED } = PATHS
const { LOGIN } = UNAUTHENTICATED
const { DASHBOARD } = AUTHENTICATED

const DISABLED_BACK_ROUTES = [LOGIN, DASHBOARD]

export default DISABLED_BACK_ROUTES
